import axios from "axios";

interface IUploadTuiFileParams {
    file: File
}

export const uploadTuiFile = async (params: IUploadTuiFileParams): Promise<void> => {
    const response = await axios.post(
        '/booking/import/uploadtui',
        params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
    return response.data;
};

export default uploadTuiFile;